import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { withLatestFrom, concatMap, map, catchError, of } from "rxjs";
import { AdminClient } from "src/api-service";
import { selectSelectedCompany } from "../../../../user/user.selectors";
import { TransferQuotesActions } from "./transfer-quotes.actions";

@Injectable()
export class TransferQuotesEffects {
    private readonly actions$ = inject(Actions);
    private readonly store = inject(Store);
    private readonly adminClient = inject(AdminClient);

    transferQuotes$ = createEffect(() =>
        this.actions$.pipe(
            ofType(TransferQuotesActions.transferQuotes),
            withLatestFrom(this.store.select(selectSelectedCompany)),
            concatMap(([{ request }, selectedCompany]) =>
                this.adminClient.transferQuotes(request, selectedCompany.id).pipe(
                    map(response =>
                        TransferQuotesActions.transferQuotesSuccess({
                            response,
                            toastKey: "ADMIN_PANEL.TRANSFER_QUOTES.TRANSFER_QUOTES_SUCCESS",
                        }),
                    ),
                    catchError(error =>
                        of(
                            TransferQuotesActions.transferQuotesFailure({
                                error,
                                toastKey: "ADMIN_PANEL.TRANSFER_QUOTES.TRANSFER_QUOTES_FAILURE",
                            }),
                        ),
                    ),
                ),
            ),
        ),
    );
}
